export default __webpack_public_path__ + "static/media/pilgrims.d70ca3f8.png";